import { render, staticRenderFns } from "./shareStorefront.vue?vue&type=template&id=5f6583b4&scoped=true&"
import script from "./shareStorefront.vue?vue&type=script&lang=js&"
export * from "./shareStorefront.vue?vue&type=script&lang=js&"
import style0 from "./shareStorefront.vue?vue&type=style&index=0&id=5f6583b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6583b4",
  null
  
)

export default component.exports